import React from "react";

const RenderCheckbox = ({ revisionsToReject = [], isChecked, onChange, readOnly = false }) => {
  // Generate the label content
  const labelContent =
    revisionsToReject.length === 0 && !readOnly ? (
      "I have reviewed the revisions mentioned on previous screen"
    ) : (
      <>
        I have reviewed{" "}
        {revisionsToReject.map((r, index) => (
          <React.Fragment key={r.rev}>
            {index > 0 && (index === revisionsToReject.length - 1 ? " and " : ", ")}
            <span style={{ color: "#0D6EFD" }}>
              Rev {r.rev} with {r.task_count} open tasks
            </span>
          </React.Fragment>
        ))}
        . I acknowledge that these revisions will be Rejected at the time of release.
      </>
    );

  return (
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: readOnly ? "default" : "pointer",
        marginTop: "-17px",
      }}
    >
      <input
        type="checkbox"
        required={!readOnly}
        readOnly={readOnly}
        checked={isChecked}
        onChange={!readOnly ? onChange : undefined}
        disabled={readOnly}
        style={{ marginLeft: "10px" }}
      />
      <p
        style={{
          fontSize: "13px",
          // fontWeight: "bold",
          marginLeft: "-5px",
        }}
      >
        {labelContent}
        {!readOnly && <span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span>}
      </p>
    </label>
  );
};

export default RenderCheckbox;
